/**
 * Category Transformer
 * Handles transformation of category data from API to application domain model
 * Single Responsibility: Category data transformation only
 */

/**
 * Transforms a single category from API response to application model
 * @param {Object} rawCategory - Raw category object from API
 * @returns {Object} Transformed category object
 */
export function transformCategory(rawCategory) {
  return {
    ...rawCategory,
    name: rawCategory.name || "",
    sorting: rawCategory.sorting || 0,
    active: rawCategory.active !== undefined ? rawCategory.active : true
  };
}

/**
 * Transforms an array of categories from API response to application models
 * @param {Array} rawCategories - Raw categories array from API
 * @returns {Array} Transformed categories array, sorted by sorting field
 */
export function transformCategories(rawCategories) {
  if (!Array.isArray(rawCategories)) {
    return [];
  }

  return rawCategories
    .map((category) => transformCategory(category))
    .sort((a, b) => (a.sorting || 0) - (b.sorting || 0));
}
